import { render, staticRenderFns } from "./WebsiteName.vue?vue&type=template&id=1172f8aa&scoped=true&"
import script from "./WebsiteName.vue?vue&type=script&lang=js&"
export * from "./WebsiteName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172f8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1172f8aa')) {
      api.createRecord('1172f8aa', component.options)
    } else {
      api.reload('1172f8aa', component.options)
    }
    module.hot.accept("./WebsiteName.vue?vue&type=template&id=1172f8aa&scoped=true&", function () {
      api.rerender('1172f8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/WebsiteName.vue"
export default component.exports